import { ENotificationsActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const updateNotificationsCount = actionGenerator<ENotificationsActionTypes.UpdateCount, number>(
  ENotificationsActionTypes.UpdateCount,
);
